import { render, staticRenderFns } from "./AudioFiles.vue?vue&type=template&id=38b5bfb1&scoped=true&"
import script from "./AudioFiles.vue?vue&type=script&lang=js&"
export * from "./AudioFiles.vue?vue&type=script&lang=js&"
import style0 from "./AudioFiles.vue?vue&type=style&index=0&id=38b5bfb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5bfb1",
  null
  
)

export default component.exports